"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpacesIceServerDefault = exports.NOT_SET = void 0;
var _uuid = require("uuid");
var NOT_SET = exports.NOT_SET = "NOT_SET";
var SpacesIceServerDefault = exports.SpacesIceServerDefault = function SpacesIceServerDefault() {
  return {
    id: {
      value: (0, _uuid.v4)()
    },
    name: "",
    description: "",
    username: "",
    credential: "",
    url: ""
  };
};